import { createContext, useContext } from "react";

/**
 * In the native app shell the Add Property modal is owned by the dashboard
 * layout so it survives the mobile sidebar unmounting. Screens rendered inside
 * that layout open the shared instance instead of mounting a second modal.
 */
const AddPropertyLauncherContext = createContext(null);

export const AddPropertyLauncherProvider = AddPropertyLauncherContext.Provider;

export function useAddPropertyLauncher() {
  return useContext(AddPropertyLauncherContext);
}

export default AddPropertyLauncherContext;
